import { toast as sonnerToast } from "sonner"

const SUCCESS_TOAST_STYLE =
  "!bg-green-700 !text-white !border !border-green-700"
const ERROR_TOAST_STYLE =
  "!bg-orange-700 !text-white !border !border-orange-700"
const INFO_TOAST_STYLE = "!bg-blue-700 !text-white !border !border-blue-700"
const WARNING_TOAST_STYLE =
  "!bg-yellow-700 !text-white !border !border-yellow-700"

export const useToast = () => {
  const success = (message: string, options = {}) => {
    sonnerToast.success(message, {
      className: SUCCESS_TOAST_STYLE,
      ...options,
    })
  }

  const error = (message: string, options = {}) => {
    sonnerToast.error(message, {
      className: ERROR_TOAST_STYLE,
      ...options,
    })
  }

  const info = (message: string, options = {}) => {
    sonnerToast.info(message, {
      className: INFO_TOAST_STYLE,
      ...options,
    })
  }

  const warning = (message: string, options = {}) => {
    sonnerToast.warning(message, {
      className: WARNING_TOAST_STYLE,
      ...options,
    })
  }

  const toast = sonnerToast

  return {
    success,
    error,
    info,
    warning,
    toast,
  }
}
